<template>
  <base-form
    :disabled="
      operateType === 'issue'
        ? !canEdit || formData.statusFlag !== '004'
        : ['002', '004', '005', '006', '007', '008'].indexOf(formData.statusFlag) != -1 || !canEdit
    "
    v-model="formData"
    :options="options"
    ref="topData"
    :rules="rules"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>
<script>
  import { mapState } from 'vuex';
  // import { dateFormatter } from '@/common/js/util';
  // import SearchTable from '@/components/form-item/search-table';
  // import InputNumber from '@/components/form-item/input-number';
  // // import DataBaseAPI from '@/api/dataBase';
  // import SearchModal from '@/components/SearchModal';
  // // import API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import AGENCY_API from '@/api/agencyContract/index';
  // import DictSelect from '@/components/DictSelect';
  import BaseForm from '@/components/form/base-form';

  export default {
    name: 'issuingForm',
    components: {
      // SearchTable,
      // SearchModal,
      // InputNumber,
      // ajaxSelect,
      // DictSelect,
      BaseForm,
    },
    props: ['type', 'canEdit'],
    data() {
      return {
        returnStatus: '',
        formData: {
          clAmount: 0, //开证金额，开证申请表单获取
          clStandardAmount: 0, //开证本位币金额
          exchangeRate: '', //开证汇率
          exchangeRateDate: '', //开证汇率日期

          branchCode: '',
          branchName: '',
          clCode: '', // 以下是开证信息 信用证号收证同
          issueDate: '', // 开证日期
          issueType: '', // 开证类型
          marginRate: '', // 银行保证金比率
          marginAmount: 0, // 银行保证金金额
          marginCurrencyCode: '', // 保证金币种编码
          marginCurrencyName: '', // 保证币种名称
          marginPayDate: '', // 保证金支付日期
          marginExchangeType: '', // 保证金汇率类型(字典)
          marginExchangeRate: '', // 保证金汇率
          marginExchangeRateDate: '', // 保证金汇率日期
          marginStandardAmount: 0, // 银行保证金本币金额
          marginPayAccount: 0, // 保证金付款银行账户
          marginPayAccountName: '', // 保证金付款银行账户名称
          // cashflowTransactionCode: '999999', // 现金流量事务代码
          cashflowTransactionName: '与现金流量表无关', //现金流量事务
          // isIndependent: false, // 是否独立开证1独立 0非独立
          // isForeignParent: false, // 外商母证开证1是 0 否
          // isRefundMargin: false, // 已退回保证金1已退 0未退
          agentBankCode: '',
          agentBank: '',
          clMaxAmount: '',
          clMaxAmountRmb: '',
          exposureRate: '',
          exposureAmount: '',
          rate: '',
          broker: '',
          brokerCode: '',
        },
        issueTypeOptions: [],

        departmentOptions: [],
        companyOptions: [],
        clTypeOptions: [],
        importExportNatureOptions: [],
        receiptList: [],
        businessNatureList: [],
        clAttrOptions: [],
        clNatureOptions: [],
        tradeTypeList: [], //经营性质
        currencyApi: '',
        currencyData: {}, //货币种类
        originalCurrencyCode: '',
        currencyCode: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        currencyOptions() {
          return this.$baseRequest.getDictListByType('all_currency');
        },
        operateType() {
          return this.$route.query.operateType;
        },
      }),
      options() {
        return [
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.clCode'),
            prop: 'clCode',
            clearable: true,
            disabled: false,
            required: this.operateType === 'issue' ? true : false,
          }, //以下是开证信息 信用证号收证同
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.issueDate'),
            prop: 'issueDate',
            clearable: true,
            disabled: false,
            // required: false,
            required: this.operateType === 'issue' ? true : false,
          }, //开证日期
          {
            type: 'dict',
            label: this.$t('tFundCreditLetter.column.issueType'),
            prop: 'issueType',
            clearable: true,
            dictType: 'cl-issueType',
            disabled: false,
            required: true,
          }, //开证类型
          {
            type: 'amountNumber',
            label: this.$t('tFundCreditLetter.column.clAmount'),
            prop: 'clAmount',
            clearable: true,
            required: true,
          }, //开证金额
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.exchangeRateDate'),
            prop: 'exchangeRateDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //开证汇率日期
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.exchangeRate'),
            prop: 'exchangeRate',
            clearable: true,
            disabled: false,
            required: true,
          }, //开证汇率
          {
            type: 'amountNumber',
            label: this.$t('tFundCreditLetter.column.clStandardAmount'),
            prop: 'clStandardAmount',
            clearable: true,
            disabled: true,
            required: true,
          }, //开证本币金额
          {
            type: 'searchTable',
            label: this.$t('tFundCreditLetter.column.branchCode'),
            prop: 'branchCode',
            clearable: true,
            disabled: false,
            isMultiple: true,
            required: true,
            searchType: 'bankAccountBranchName',
            extraData: {
              companyCode: this.userInfo.companyCode || '',
            },
            checkRowKeys: [this.formData['branchCode']],
            currentValue: this.formData.branchName,
          }, //开证银行
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.marginRate'),
            prop: 'marginRate',
            clearable: true,
            disabled: false,
          }, //银行保证金比率
          {
            type: 'amountNumber',
            label: this.$t('tFundCreditLetter.column.marginAmount'),
            prop: 'marginAmount',
            clearable: true,
            disabled: false,
            required: true,
          }, //银行保证金金额
          {
            type: 'dict',
            dictType: 'all_currency',
            label: this.$t('tFundCreditLetter.column.marginCurrencyCode'),
            prop: 'marginCurrencyCode',
            clearable: true,
            disabled: false,
            required: this.formData.marginAmount != 0,
          }, //保证金币种编码
          {
            type: 'date',
            label: this.$t('tFundCreditLetter.column.marginPayDate'),
            prop: 'marginPayDate',
            clearable: true,
            disabled: false,
            required: this.formData.marginAmount != 0,
          }, //保证金支付日期
          {
            type: 'input',
            label: this.$t('tFundCreditLetter.column.marginExchangeRate'),
            prop: 'marginExchangeRate',
            clearable: true,
            disabled: false,
            required: this.formData.marginAmount != 0,
          }, //保证金汇率
          {
            type: 'amountNumber',
            label: this.$t('tFundCreditLetter.column.marginStandardAmount'),
            prop: 'marginStandardAmount',
            clearable: true,
            disabled: true,
            required: this.formData.marginAmount != 0,
          }, //银行保证金本币金额
          {
            type: 'searchTable',
            label: this.$t('tFundCreditLetter.column.marginReceiveAccount'),
            prop: 'marginReceiveAccount',
            clearable: true,
            required: this.formData.marginAmount != 0,
            isMultiple: true,
            searchType: 'bankAccountBranchName',
            extraData: {
              companyCode: this.userInfo.companyCode,
              secondaryClassCode: this.formData.clType == '001' ? 'ASC18' : 'ASC17',
            },
            checkRowKeys: [this.formData['marginReceiveAccount']],
            currentValue: this.formData.marginReceiveAccount,
          }, //保证金转入银行账户
          {
            type: 'searchTable',
            label: this.$t('tFundCreditLetter.column.marginPayAccount'),
            prop: 'marginPayAccount',
            clearable: true,
            required: this.formData.marginAmount != 0,
            isMultiple: true,
            searchType: 'bankAccountBranchName',
            extraData: { companyCode: this.userInfo.companyCode },
            checkRowKeys: [this.formData['marginPayAccount']],
            currentValue: this.formData.marginPayAccount,
          }, //保证金转出银行账户
          // 代开行信用证编号
          {
            type: 'input',
            label: '代开行信用证编号',
            prop: 'agentBankCode',
            clearable: true,
            disabled: false,
          },
          // 代开行
          {
            type: 'searchTable',
            label: '代开行',
            prop: 'agentBank',
            clearable: true,
            disabled: false,
            isMultiple: true,
            required: false,
            searchType: 'bankAccountBranchName',
            extraData: { companyCode: this.userInfo.companyCode },
            // currentValue: this.formData.applyBranchName,
          },
          // 最大开证金额
          {
            type: 'input',
            label: '最大开证金额',
            prop: 'clMaxAmount',
            clearable: true,
            disabled: true,
            required: true,
          },
          // 最大开证金额
          {
            type: 'input',
            label: '开证最大金额(人民币)',
            prop: 'clMaxAmountRmb',
            clearable: true,
            disabled: true,
            required: true,
          },
          {
            type: 'input',
            label: '敞口比例%',
            prop: 'exposureRate',
            clearable: true,
            disabled: false,
            required: true,
          },
          {
            type: 'input',
            label: '敞口额度',
            prop: 'exposureAmount',
            clearable: true,
            disabled: true,
            required: false,
          },
          {
            type: 'input',
            label: '费率',
            prop: 'rate',
            clearable: true,
            disabled: false,
          },
          {
            type: 'searchTable',
            label: '经办人',
            prop: 'broker',
            clearable: true,
            disabled: false,
            isMultiple: true,
            required: true,
            searchType: 'personnel',
            extraData: {
              companyCode: this.userInfo.companyCode,
              departmentCode: this.userInfo.departmentCode,
            },
            name: 'broker',
            code: 'brokerCode',
            currentValue: this.formData.broker,
          },
          // {
          //   type: 'input',
          //   label: '经办人',
          //   prop: 'broker',
          //   clearable: true,
          //   disabled: false,
          //   required: true,
          // },
          // {
          //   type: 'searchTable',
          //   label: this.$t('tFundCreditLetter.column.cashflowTransactionCode'),
          //   prop: 'cashflowTransactionCode',
          //   clearable: true,
          //   disabled: this.formData.marginAmount == 0,
          //   required: this.formData.marginAmount != 0,
          //   isMultiple: true,
          //   searchType: 'cashflow',
          //   propName: 'cashflowCode',
          //   checkRowKeys: [this.formData['cashflowTransactionCode']],
          //   currentValue: this.formData.cashflowTransactionCode,
          // }, //现金流量事务代码
          // {
          //   type: 'checkbox',
          //   label: this.$t('tFundCreditLetter.column.isIndependent'),
          //   prop: 'isIndependent',
          //   clearable: true,
          //   disabled: false,
          // }, //是否独立开证1独立 0非独立
          // {
          //   type: 'checkbox',
          //   label: this.$t('tFundCreditLetter.column.isForeignParent'),
          //   prop: 'isForeignParent',
          //   clearable: true,
          //   disabled: false,
          // }, //外商母证开证1是 0 否
          // {
          //   type: 'checkbox',
          //   label: this.$t('tFundCreditLetter.column.isRefundMargin'),
          //   prop: 'isRefundMargin',
          //   clearable: true,
          //   disabled: false,
          // }, //已退回保证金1已退 0未退
        ];
      },
      rules() {
        return {};
      },
    },

    watch: {},
    mounted() {},
    methods: {
      handleChange(v, prop) {
        console.log(v, prop, 'prop');
        console.log(v.marginAmount);
        if (prop == 'branchCode') {
          let obj = { ...v[prop] };
          if (obj && obj[0] && obj[0].branchCode) {
            this.formData.branchCode = obj[0].branchCode;
            this.formData.branchName = obj[0].branchName;
            this.formData.marginPayAccount = obj[0].bankAccountNum;
            this.formData.marginPayAccountName = obj[0].bankAccountName;
            this.formData.marginReceiveAccount = obj[0].bankAccountNum;
            this.formData.marginReceiveAccountName = obj[0].bankAccountName;
            this.formData.marginRate = obj[0].clMarginRate;
            if (!this.formData.marginRate) {
              this.$message({
                showClose: true,
                message: '该银行未设置保证金比例！',
                type: 'error',
                duration: 5000,
              });
            }
          } else {
            this.formData.branchCode = '';
            this.formData.branchName = '';
            this.formData.marginPayAccount = '';
            this.formData.marginPayAccountName = '';
            this.formData.marginReceiveAccount = '';
            this.formData.marginReceiveAccountName = '';
            this.formData.marginRate = '';
          }
        } else if (prop == 'marginPayAccount') {
          let obj = { ...v[prop] };
          if (obj && obj[0] && obj[0].bankAccountNum) {
            this.formData.marginPayAccount = obj[0].bankAccountNum;
            this.formData.marginPayAccountName = obj[0].bankAccountName;
            this.formData.marginRate = obj[0].clMarginRate;
            this.changeMarginRate();
            if (!this.formData.marginRate) {
              this.$message({
                showClose: true,
                message: '该银行未设置保证金比例！',
                type: 'error',
                duration: 5000,
              });
            }
          } else {
            this.formData.marginPayAccount = '';
            this.formData.marginPayAccountName = '';
            this.formData.marginRate = '';
          }
        } else if (prop == 'broker') {
          let obj = { ...v[prop] };
          console.log(obj, 'obj');
          if (obj) {
            this.formData.broker = obj[0].personName;
            this.formData.brokerCode = obj[0].personNo;
          }
        } else if (prop == 'marginReceiveAccount') {
          let obj = { ...v[prop] };
          if (obj) {
            this.formData.marginReceiveAccount = obj[0].bankAccountNum;
            this.formData.marginReceiveAccountName = obj[0].bankAccountName;
          }
          // else{
          //   this.formData.marginReceiveAccount = '';
          //   this.formData.marginReceiveAccountName = '';
          // }
        } else if (prop == 'marginCurrencyCode') {
          this.changeCurrency(this.formData.marginCurrencyCode);
        }
        //  else if (prop == 'cashflowTransactionCode') {
        //   let obj = { ...v[prop] };
        //   this.formData.cashflowTransactionCode = obj[0].cashflowCode;
        // }
        else if (prop == 'exchangeRateDate') {
          this.getRate('marginExchangeRate');
          this.getRate('exchangeRate');
        } else if (prop == 'clAmount') {
          this.calClStandardAmount();
        } else if (prop == 'issueDate') {
          //信用证开证信息中的汇率日期默认开证日期
          if (!v['exchangeRateDate']) {
            v['exchangeRateDate'] = v[prop];
          }
        } else if (prop == 'marginRate') {
          this.changeMarginRate();
        } else if (prop == 'marginExchangeRate') {
          this.calMarginStandardAmount();
        } else if (prop == 'exchangeRate') {
          this.calClStandardAmount(); //计算开证本币
          this.changeMarginRate(); // 计算保证金
          this.getClMaxAmountRmb(); // 计算开证最大金额(人民币)
        } else if (prop == 'marginAmount') {
          console.log('11111111');
          this.calMarginStandardAmount();
        }
      },
      chooseTable(row) {
        console.log(row);
      },
      //保证金比率变更
      changeMarginRate() {
        this.formData.marginAmount = this.$cal.calCommon(
          this.$cal.calCommon(this.formData.marginRate, this.formData.clAmount, '*'),
          100,
          '/',
          'amount'
        );
        this.formData.marginStandardAmount = this.$cal.calCommon(
          this.formData.marginExchangeRate,
          this.formData.marginAmount,
          '*',
          'amount'
        );
        if (this.formData.marginAmount == 0) {
          this.formData.marginCurrencyCode = null;
          this.formData.marginCurrencyName = null;
          this.formData.marginPayDate = null;
          this.formData.marginStandardAmount = null;
          // this.formData.cashflowTransactionCode = null;
        } else {
          // if (!this.formData.cashflowTransactionCode)
          //   this.formData.cashflowTransactionCode = '999999';
        }
        // 计算敞口比例
        this.formData.exposureRate = this.$cal.calCommon(
          100,
          this.formData.marginRate,
          '-',
          'amount'
        );
      },
      // 计算开证最大金额(人民币)
      getClMaxAmountRmb() {
        this.formData.clMaxAmountRmb = this.$cal.calCommon(
          this.formData.clMaxAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
      },
      // 计算开证金额本币
      calClStandardAmount() {
        let clStandardAmount = this.$cal.calCommon(
          this.formData.exchangeRate,
          this.formData.clAmount,
          '*',
          'amount'
        );
        this.formData.clStandardAmount = clStandardAmount;
      },
      // 计算保证金本币
      calMarginStandardAmount() {
        let marginStandardAmount = this.$cal.calCommon(
          this.formData.marginExchangeRate,
          this.formData.marginAmount,
          '*',
          'amount'
        );
        this.formData.marginStandardAmount = marginStandardAmount;
        // 计算敞口额度
        console.log(this.formData.clMaxAmount, this.formData.marginAmount, '3333');

        let exposureAmount = this.$cal.calCommon(
          this.formData.clMaxAmount,
          this.formData.marginAmount,
          '-',
          'amount'
        );
        console.log(exposureAmount, '2222222222');
        this.formData.exposureAmount = exposureAmount;
      },
      // 计算开证最大金额
      calClMaxAmount(val) {
        let clMaxAmount = this.$cal.calCommon(
          this.formData.clAmount,
          1 + Number(val),
          '*',
          'amount'
        );
        this.formData.clMaxAmount = clMaxAmount;
        this.formData.clMaxAmountRmb = this.$cal.calCommon(
          this.formData.clMaxAmount,
          this.formData.exchangeRate,
          '*',
          'amount'
        );
      },
      //切换币别
      changeCurrency(val) {
        this.formData.marginCurrencyName = this.$baseRequest.getDictValueByType(
          'all_currency',
          val
        );
        this.formData.marginCurrencyCode = val;
        this.getRate('marginExchangeRate');
      },
      // 获取汇率
      getRate(rateFlag) {
        let currencyCode =
          rateFlag == 'marginExchangeRate'
            ? this.formData.marginCurrencyCode
            : this.formData.currencyCode;
        if (
          this.formData.companyCurrencyCode &&
          currencyCode &&
          this.formData.companyCurrencyCode === currencyCode
        ) {
          // this.feeInfo.exchangeType = 'User'
          this.formData[rateFlag] = 1;
          rateFlag == 'marginExchangeRate'
            ? this.calMarginStandardAmount()
            : this.calClStandardAmount();
        } else if (this.formData.companyCurrencyCode && currencyCode) {
          this.getTaxRate(rateFlag);
        }
      },
      //获取汇率
      getTaxRate(rateFlag) {
        let currencyCode =
          rateFlag == 'marginExchangeRate'
            ? this.formData.marginCurrencyCode
            : this.formData.currencyCode;
        let exchangeDate =
          rateFlag == 'marginExchangeRate'
            ? this.formData.issueDate
            : this.formData.exchangeRateDate;
        console.log(exchangeDate);
        if (currencyCode || this.formData.companyCurrencyCode) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: currencyCode,
            toCurrencyCode: this.formData.companyCurrencyCode,
            exchangeType: 'Cooperate',
          };
          if (exchangeDate)
            params['exchangeDate'] = this.$baseRequest.getBeginOfMonth(exchangeDate);
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.formData[rateFlag] = res.positiveRate;
              rateFlag == 'marginExchangeRate'
                ? this.calMarginStandardAmount()
                : this.calClStandardAmount();
            } else {
              this.formData[rateFlag] = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      getDetail(allDetail) {
        console.log(allDetail, 'allDetail-----');
        this.formData = allDetail;
        if (this.formData.statusFlag == '004' && !this.formData.clCode) this.changeMarginRate();
      },

      // 返回数据
      exportChildData() {
        return new Promise((resolve, reject) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              resolve(this.formData);
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .widthStyle {
    width: 100%;
  }
</style>
